var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import Errors from "../shared/errors";
import Busy from "../shared/busy";
import { getXSRF } from "../../src/Services/Shared/FetchService";
const PAGE_SIZE = 10;
class AlertCoordinatorsList extends PureComponent {
    static fetchAlertCoordinators(alertId, sort, order, max, offset) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/alertCoordinator/list?alertId=${alertId}&isDefault=false&sort=${sort}&order=${order}&max=${max}&offset=${offset}`, { credentials: "include" });
            const responseJson = yield response.json();
            return responseJson.data;
        });
    }
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.state = {
            alertCoordinators: [],
            errors: [],
            isLoading: false,
            isDeleting: false,
            isSorting: false,
            isPaging: false,
            sortingProperties: {
                sort: "location",
                order: "asc",
                offset: 0,
            },
            pageIndex: 0,
            deletingCoordinator: null,
        };
        this.allowPaging = () => {
            if (this.state.pageIndex === 0) {
                if (PAGE_SIZE + 1 > this.state.alertCoordinators.length) {
                    return false;
                }
                return true;
            }
            return true;
        };
        this.onSort = (name) => __awaiter(this, void 0, void 0, function* () {
            const newState = Object.assign({}, this.state.sortingProperties);
            if (name === this.state.sortingProperties.sort) {
                // @ts-expect-error - TS2540 - Cannot assign to 'order' because it is a read-only property.
                newState.order =
                    this.state.sortingProperties.order === "asc" ? "desc" : "asc";
            }
            else {
                // @ts-expect-error - TS2540 - Cannot assign to 'sort' because it is a read-only property.
                newState.sort = name;
                // @ts-expect-error - TS2540 - Cannot assign to 'order' because it is a read-only property.
                newState.order = "asc";
            }
            this.setState({
                sortingProperties: newState,
                isSorting: true,
            }, () => __awaiter(this, void 0, void 0, function* () {
                yield this.loadAlertCoordinators();
                this.setState({ isSorting: false });
            }));
        });
        this.renderSortButton = (text, sort) => (_jsxs("button", { type: "button", className: "btn btn-link font-weight-bold p-0", onClick: () => this.onSort(sort), children: [text, " ", this.renderSortIndicator(sort)] }));
        this.goToPrevPage = () => {
            this.setState((prevState) => ({
                isPaging: true,
                pageIndex: prevState.pageIndex - 1,
            }), () => __awaiter(this, void 0, void 0, function* () {
                yield this.loadAlertCoordinators();
                this.setState({ isPaging: false });
            }));
        };
        this.goToNextPage = () => {
            this.setState((prevState) => ({
                isPaging: true,
                pageIndex: prevState.pageIndex + 1,
            }), () => __awaiter(this, void 0, void 0, function* () {
                yield this.loadAlertCoordinators();
                this.setState({ isPaging: false });
            }));
        };
        this.delete = this.delete.bind(this);
    }
    componentDidMount() {
        this.refresh();
    }
    // @ts-expect-error - TS7006 - Parameter 'message' implicitly has an 'any' type.
    onError(message) {
        this.setState({ errors: [...this.state.errors, message] });
    }
    loadAlertCoordinators() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const offset = this.state.pageIndex * PAGE_SIZE;
                const alertCoordinators = yield AlertCoordinatorsList.fetchAlertCoordinators(this.props.alertId, this.state.sortingProperties.sort, this.state.sortingProperties.order, PAGE_SIZE + 1, offset);
                this.setState({ alertCoordinators });
            }
            catch (err) {
                this.onError(`Error loading alert coordinators: ${err}`);
            }
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isLoading: true });
            yield this.loadAlertCoordinators();
            this.setState({ isLoading: false });
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'coordinator' implicitly has an 'any' type.
    delete(coordinator) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({
                    isDeleting: true,
                    deletingCoordinator: coordinator,
                });
                const response = yield fetch(`/aviso/alertCoordinator/delete?id=${coordinator.id}`, {
                    credentials: "include",
                    method: "POST",
                    headers: {
                        "X-XSRF-TOKEN": getXSRF(),
                    },
                });
                const responseJson = yield response.json();
                if (responseJson.success) {
                    this.refresh();
                }
                else {
                    this.onError(responseJson.message);
                }
            }
            catch (err) {
                this.onError(`Error removing alert coordinator: ${err}`);
            }
            finally {
                this.setState({
                    isDeleting: false,
                    deletingCoordinator: null,
                });
            }
        });
    }
    renderSortIndicator(sort) {
        if (this.state.sortingProperties.sort === sort) {
            if (this.state.isSorting) {
                return _jsx(Busy, { isBusy: true });
            }
            if (this.state.sortingProperties.order === "desc") {
                return _jsx("span", { className: "fa fa-fw fa-sort-down" });
            }
            return _jsx("span", { className: "fa fa-fw fa-sort-up" });
        }
        return _jsx("span", { className: "fa fa-fw" });
    }
    renderAlertCoordinators() {
        if (!this.state.alertCoordinators || !this.state.alertCoordinators.length) {
            return "No Alert Coordinators configured";
        }
        return (_jsxs("div", { children: [_jsxs("table", { className: "table table-bordered table-striped mt-2", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: this.renderSortButton("Student Campus Location", "location") }), _jsx("th", { children: this.renderSortButton("Staff Initiated Alert Reason", "alert") }), _jsx("th", { children: this.renderSortButton("Coordinator", "name") }), this.props.allowDelete && _jsx("th", {})] }) }), _jsx("tbody", { children: this.state.alertCoordinators
                                .slice(0, PAGE_SIZE)
                                .map((coordinator) => (
                            // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                            _jsxs("tr", { children: [_jsx("td", { children: coordinator.location
                                            ? // @ts-expect-error - TS2339 - Property 'location' does not exist on type 'never'.
                                                coordinator.location.name
                                            : "All Locations" }), _jsx("td", { children: coordinator.earlyAlertReason
                                            ? // @ts-expect-error - TS2339 - Property 'earlyAlertReason' does not exist on type 'never'.
                                                coordinator.earlyAlertReason.name
                                            : "All Reasons" }), _jsxs("td", { children: [_jsx("span", { className: "pr-2 text-danger fa fa-exclamation-triangle", 
                                                // @ts-expect-error - TS2339 - Property 'person' does not exist on type 'never'.
                                                hidden: coordinator.person.canSeeAlert, title: "This user does not have sufficient permissions to view these alerts", "aria-hidden": "true" }), _jsx("span", { className: "sr-only sr-select-none", children: "This user does not have sufficient permissions to view these alerts" }), coordinator.person.fullName, coordinator.person.institutionId && (_jsxs("span", { className: "text-muted", children: ["\u00A0(", coordinator.person.institutionId, ")"] }))] }), this.props.allowDelete && (_jsx("td", { className: "text-center", children: _jsxs("button", { type: "button", className: "btn btn-link text-danger", title: "Delete", onClick: () => this.delete(coordinator), disabled: this.state.isDeleting &&
                                                this.state.deletingCoordinator === coordinator, children: [this.state.isDeleting &&
                                                    this.state.deletingCoordinator === coordinator ? (_jsx(Busy, {})) : (_jsx("span", { className: "fas fa-trash", "aria-hidden": "true" })), _jsx("span", { className: "sr-only", children: "Delete" })] }) }))] }, coordinator.id))) })] }), this.allowPaging() && (_jsxs("div", { children: [_jsxs("div", { className: "btn-group", role: "group", "aria-label": "Paging", children: [_jsxs("button", { className: "btn btn-primary-outline", disabled: this.state.pageIndex === 0, onClick: this.goToPrevPage, type: "button", children: [_jsx("span", { className: "fa fa-chevron-left" }), " Prev"] }), _jsxs("button", { className: "btn btn-primary-outline", disabled: PAGE_SIZE >= this.state.alertCoordinators.length, onClick: this.goToNextPage, type: "button", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right" })] })] }), _jsx("span", { className: "ml-2", children: _jsx(Busy, { isBusy: this.state.isPaging }) })] }))] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(Busy, { isBusy: this.state.isLoading }), this.renderAlertCoordinators(), _jsx(Errors, { errors: this.state.errors })] }));
    }
}
AlertCoordinatorsList.defaultProps = {
    allowDelete: false,
};
export default AlertCoordinatorsList;
